import { useEffect, useState } from 'react';
import { Card, Table, Button, Badge, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { formatDateTime } from '../shared/dateFormat';

const STATUS_BADGE = {
  demo_scheduled: 'warning',
  demo_completed: 'info',
  hired: 'success',
  rejected: 'secondary',
  cancelled: 'secondary',
};

export default function StudentBookings() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState({ type: '', text: '' });

  const load = async () => {
    setLoading(true);
    try { setRows(await api.get('/student/bookings')); }
    catch (e) { setMsg({ type: 'danger', text: e.message }); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const act = async (id, verb, row) => {
    let prompt;
    if (verb === 'hire') {
      prompt = 'Hire this teacher? The held amount will be consumed as first month\'s tuition and cannot be refunded.';
    } else if (row?.status === 'demo_completed') {
      const monthly = Number(row.monthly_fee);
      const demo = Number(row.demo_fee);
      prompt = `Reject this teacher?\n\nYou get back ₹${monthly.toFixed(0)} (tuition).\nThe ₹${demo.toFixed(0)} demo fee stays with the platform since the teacher conducted the demo.`;
    } else {
      prompt = 'Cancel this booking and refund the full amount back to your wallet? (Teacher hasn\'t conducted the demo yet.)';
    }
    if (!window.confirm(prompt)) return;
    try {
      const r = await api.post(`/student/bookings/${id}/${verb}`);
      if (verb === 'hire') {
        setMsg({ type: 'success', text: 'Booking converted to hire.' });
      } else {
        const refunded = r?.refunded ?? 0;
        const kept = r?.demo_fee_kept ?? 0;
        setMsg({ type: 'success', text: `Refunded ₹${Number(refunded).toFixed(0)} to wallet${kept > 0 ? ` (₹${Number(kept).toFixed(0)} demo fee kept)` : ''}.` });
      }
      await load();
    } catch (e) { setMsg({ type: 'danger', text: e.message }); }
  };

  if (loading) return <div className="text-center py-5"><Spinner /></div>;

  return (
    <>
      <h3 className="mb-4">My Bookings</h3>
      {msg.text && <Alert variant={msg.type} dismissible onClose={() => setMsg({ type: '', text: '' })}>{msg.text}</Alert>}

      {rows.length === 0 ? (
        <Card className="shadow-sm">
          <Card.Body className="text-center">
            <p className="text-muted mb-2">You don't have any bookings yet.</p>
            <Button as={Link} to="/student/teachers">Browse teachers</Button>
          </Card.Body>
        </Card>
      ) : (
        <Table bordered hover responsive className="bg-white">
          <thead className="table-dark"><tr><th>Teacher</th><th>City</th><th>Slot</th><th>Held</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {rows.map((b) => (
              <tr key={b.id}>
                <td>{b.teacher_name}</td>
                <td>{b.city || '-'}</td>
                <td>{formatDateTime(b.demo_slot_at)}</td>
                <td>₹{Number(b.amount_held).toFixed(0)}</td>
                <td><Badge bg={STATUS_BADGE[b.status] || 'secondary'}>{b.status.replace('_', ' ')}</Badge></td>
                <td>
                  {b.status === 'demo_scheduled' && (
                    <Button size="sm" variant="outline-danger" onClick={() => act(b.id, 'reject', b)}>Cancel (full refund)</Button>
                  )}
                  {b.status === 'demo_completed' && (
                    <>
                      <Button size="sm" variant="success" className="me-1" onClick={() => act(b.id, 'hire')}>Hire</Button>
                      <Button size="sm" variant="outline-danger" onClick={() => act(b.id, 'reject', b)}>Reject (refund tuition only)</Button>
                    </>
                  )}
                  {b.status === 'hired' && b.hire_id && (
                    <Button size="sm" as={Link} to={`/student/classes`} variant="outline-primary">View class</Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}
